import React from "react";

type EstateCardProps = {
  item: any;
  onClick: () => void;
  formatKoreanMoney: (amount: any) => string;
};

const EstateCard: React.FC<EstateCardProps> = ({
  item,
  onClick,
  formatKoreanMoney,
}) => (
  <div
    className="min-w-[180px] max-w-[220px] bg-red-50 border border-red-100 rounded-lg shadow p-3 cursor-pointer flex flex-col gap-1 hover:shadow-md transition"
    onClick={onClick}
  >
    <div className="font-bold text-red-600">❤️ {item.idx}</div>
    <div className="text-sm">{item.address}</div>
    <div className="text-xs text-gray-500">{item.meamul_description}</div>
    <div className="text-base font-semibold">
      {formatKoreanMoney(item.deal_amount)}
    </div>
  </div>
);

export default EstateCard;
